import LinkPropsType from "../../Types/LinkPropsType";

const StyledLink = ({
  text,
  className = "blueLink",
  link,
  onClick,
}: LinkPropsType) => {
  return (
    <a className={className} href={link} onClick={onClick}>
      {text}
    </a>
  );
};

export default StyledLink;
